import * as l from "react";
const e = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12c0 3.673-3.378 7-8 7s-8-3.327-8-7 3.378-7 8-7 8 3.327 8 7zm2 0c0 4.97-4.477 9-10 9S2 16.97 2 12s4.477-9 10-9 10 4.03 10 9zm-6.447-2.106a1 1 0 00.894-1.788l-1.105-.553a3 3 0 00-2.684 0l-.21.105a1 1 0 01-.895 0l-.211-.105a3 3 0 00-2.684 0l-1.105.553a1 1 0 10.894 1.788l1.106-.552a1 1 0 01.894 0l.211.105a3 3 0 002.684 0l.21-.105a1 1 0 01.895 0l1.106.552zm-8.447 4.659a1 1 0 011.341-.447l1.106.552a1 1 0 00.894 0l.211-.105a3 3 0 012.684 0l.21.105a1 1 0 00.895 0l1.106-.552a1 1 0 11.894 1.788l-1.105.553a3 3 0 01-2.684 0l-.21-.105a1 1 0 00-.895 0l-.211.105a3 3 0 01-2.684 0l-1.105-.553a1 1 0 01-.447-1.341zm-1.553-2.947a1 1 0 10.894 1.788l1.106-.552a1 1 0 01.894 0l.211.105a3 3 0 002.684 0l.21-.105a1 1 0 01.895 0l.211.105a3 3 0 002.684 0l.21-.105a1 1 0 01.895 0l1.106.552a1 1 0 10.894-1.788l-1.105-.553a3 3 0 00-2.684 0l-.21.105a1 1 0 01-.895 0l-.211-.105a3 3 0 00-2.684 0l-.21.105a1 1 0 01-.895 0l-.211-.105a3 3 0 00-2.684 0l-1.105.553z",
      fill: "#2d6ded"
    }
  )
), t = e;
export {
  t as default
};
